import { saveAs } from 'file-saver';

/**
 * 下载Blob文件
 * 使用file-saver库以确保跨浏览器兼容性，特别是Safari
 * 
 * @param data - 要下载的数据（Blob、File、string或ArrayBuffer）
 * @param filename - 文件名
 */
export function downloadBlobFile(data: Blob | File | string | ArrayBuffer, filename: string) {
  // Ensure data is a Blob or File instance
  let blob: Blob;
  if (data instanceof Blob || data instanceof File) {
    blob = data;
  } else if (typeof data === 'string') {
    // Convert string to Blob
    blob = new Blob([data], { type: 'application/octet-stream' });
  } else if (data instanceof ArrayBuffer) {
    // Convert ArrayBuffer to Blob
    blob = new Blob([data], { type: 'application/octet-stream' });
  } else {
    // Fallback: try to convert to Blob
    blob = new Blob([data as any], { type: 'application/octet-stream' });
  }

  // 清理文件名，移除可能导致Safari问题的字符
  // Safari对文件名中的换行符特别敏感，可能导致下载为"example.com"
  const cleanFilename = filename
    .trim()
    // 移除换行符、制表符等空白字符（这是导致Safari下载为"example.com"的主要原因）
    .replace(/[\r\n\t]/g, '')
    // 移除Windows文件名不允许的特殊字符
    .replace(/[<>:"/\\|?*]/g, '_')
    // 移除连续的下划线
    .replace(/_+/g, '_')
    // 移除开头和结尾的下划线
    .replace(/^_+|_+$/g, '');

  // 使用file-saver的saveAs函数，它已经处理了Safari的兼容性问题
  // file-saver库内部会处理不同浏览器的差异，包括Safari对download属性的限制
  saveAs(blob, cleanFilename);
} 